export default __webpack_public_path__ + "static/media/csdTheme.6354f325.png";